import React from 'react';
import { cn } from '../../utils/cn';

/**
 * Sticky modal / drawer header — stacks on mobile, row on sm+.
 */
export function ModalHeader({ className, title, description, actions, children, ...rest }) {
  return (
    <div
      className={cn(
        'sticky top-0 z-10 flex min-w-0 flex-col gap-3 border-b border-slate-200 bg-white px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:px-6 sm:py-4',
        className
      )}
      {...rest}
    >
      <div className="min-w-0 flex-1">
        {title ? <h3 className="text-lg font-black text-slate-900 sm:text-xl">{title}</h3> : null}
        {description ? (
          <p className="mt-0.5 text-sm font-medium text-slate-500">{description}</p>
        ) : null}
        {children}
      </div>
      {actions ? (
        <div className="flex w-full min-w-0 shrink-0 flex-col gap-2 sm:w-auto sm:flex-row sm:items-center sm:justify-end [&_button]:min-h-[44px] [&_button]:w-full [&_button]:touch-manipulation sm:[&_button]:w-auto">
          {actions}
        </div>
      ) : null}
    </div>
  );
}
